import { styled } from '@linaria/react';
import theme from '../../theme';

const { pageHeaderHeight, adminContentPadding } = theme.constants;

// ==================== State Components (Loading/Error/NotFound) ====================

export const LoadingContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 50vh;
    text-align: center;

    h2 {
        color: #dc3545;
        margin-bottom: 1rem;
    }

    p {
        color: #6c757d;
        margin-bottom: 1.5rem;
        font-size: 1.1rem;
    }
`;

export const LoadingSpinner = styled.div`
    width: 40px;
    height: 40px;
    border: 4px solid #e3e3e3;
    border-top: 4px solid #6c757d;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 1rem;

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
`;

export const ErrorContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 50vh;
    text-align: center;

    h2 {
        color: #dc3545;
        margin-bottom: 1rem;
    }

    p {
        color: #6c757d;
        margin-bottom: 1.5rem;
        font-size: 1.1rem;
    }
`;

export const ErrorActions = styled.div`
    display: flex;
    gap: 1rem;
`;

// Using global TextButton for consistent styling
export { TextButton as RetryButton } from '../../styles/button.style';
export { TextButton as BackButton } from '../../styles/button.style';

export const NotFoundContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 50vh;
    text-align: center;

    h2 {
        color: #dc3545;
        margin-bottom: 1rem;
    }

    p {
        color: #6c757d;
        margin-bottom: 1.5rem;
        font-size: 1.1rem;
    }
`;

// ==================== Layout Components ====================

export const DefaultProductLabel = styled.span`
    /* Inherits styling from parent, can add specific styles if needed */
`;

export const ProductPageContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: calc(100vh - ${pageHeaderHeight} - ${adminContentPadding} - ${adminContentPadding});
    overflow: hidden;
    background-color: #f8f9fa;

    @media (max-width: 768px) {
        padding: 1rem;
        height: auto;
        min-height: calc(100vh - ${pageHeaderHeight});
        overflow: visible;
    }
`;

export const ProductContent = styled.div`
    /* Container for tab menu and product layout */
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    overflow: hidden;
`;

export const ProductLayout = styled.div`
    display: grid;
    grid-template-columns: 300px calc(100% - 300px);
    gap: 0.5rem;
    align-items: start;
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    margin-top: 0.25rem;

    /* Custom scrollbar styling */
    &::-webkit-scrollbar {
        width: 8px;
    }

    &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 4px;

        &:hover {
            background: #a1a1a1;
        }
    }

    @media (max-width: 1024px) {
        grid-template-columns: 1fr;
        gap: 1rem;
    }

    @media (max-width: 768px) {
        display: flex;
        flex-direction: column;
        overflow: visible;
        flex: none;
        height: auto;
        min-height: auto;
    }
`;

export const Sidebar = styled.div`
    @media (max-width: 1024px) {
        order: 2;
    }

    @media (max-width: 768px) {
        order: 1;
    }
`;

export const MainContent = styled.div`
    @media (max-width: 1024px) {
        order: 1;
    }

    @media (max-width: 768px) {
        order: 2;
    }
`;

export const ProductSections = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2rem;
   
    @media (max-width: 1024px) {
        height: auto;
    }
`;

// ==================== External IDs Section ====================

export const ExternalReferencesCard = styled.div`
    background: white;
    border-radius: 4px;
    padding: 2rem;
    border: 1px solid #e9ecef;

    @media (max-width: 768px) {
        padding: 1.5rem;
    }
`;

export const ExternalReferencesTitle = styled.h2`
    color: #333;
    margin: 0 0 1.5rem 0;
    font-size: 1.5rem;
    font-weight: 700;
    border-bottom: 3px solid #6c757d;
    padding-bottom: 0.5rem;
`;

export const ExternalIdsList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
`;

export const ExternalIdItem = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.25rem 0.5rem;
    background: #f8f9fa;
    border-radius: 4px;
    border-left: 4px solid #dee2e6;

    label {
        font-weight: 600;
        color: #495057;
        margin-right: 1rem;
        min-width: 120px;
    }

    span {
        color: #333;
        text-align: right;
        flex: 1;
        word-break: break-word;
    }
`;
